// DEPENDENCIES //
import { Link } from "react-router-dom";

// IMAGES //

// STYLES // 
import "./tools.css"

export default function Tools() {
    return (
        <div id="tools">
            <div className="tools_text">
                    <ul>
                        <li>CSS | Django | Express.js | HTML | JavaScript | JSON | MongoDB | Node.js | Pixi.js | PostgreSQL | Python | React.js | Socket.io</li>
                        <li>+</li>
                        <li>Adobe Creative Cloud (Illustrator, InDesign, Photoshop & Premiere Pro) | Autodesk Sketchbook Pro | OBS Studio | Procreate | VS Code</li>
                        <li>+</li>
                        <li>Crayon | Marker (Posca, Prismacolor & Zig Kuretake) | Mixed Media | Paint (Acrylic & Oil) | Wood | Pencil & Ink</li>
                        <li>+</li>
                        <li>PC (Mac & Windows) | Tula Mics | Wacom Intuos</li>
                    </ul>
            </div>

        </div>
    )
}